import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconCheck from '@spothero/icons/check';
import Card from 'common/card/Card';

const VALUE_PROPS = [
    'Free cancellation up to your start time',
    'Easily edit or extend your reservation',
    'Excellent customer support',
];

const CheckoutValueProps = ({className, showCancellationValueProp}) => {
    const classes = classNames('CheckoutValueProps-container', className);

    return (
        <div className={classes}>
            <Card className="CheckoutValueProps">
                {VALUE_PROPS.map((value, i) => {
                    if (!showCancellationValueProp && i === 0) {
                        return null;
                    }

                    return (
                        <div key={i} className="CheckoutValueProps-item">
                            <span className="CheckoutValueProps-item-icon">
                                <IconCheck />
                            </span>
                            <p>{value}</p>
                        </div>
                    );
                })}
            </Card>
        </div>
    );
};

CheckoutValueProps.propTypes = {
    className: PropTypes.string,
    showCancellationValueProp: PropTypes.bool.isRequired,
};

export default CheckoutValueProps;
